/*
  Safety reports — progressive enhancement for the report cards.

  Desktop: lazily copies the iframe's data-src to src the first time a
  report card is activated, then lets the theme's aria-controls wiring
  open the x-modal (no PDF loads until a card is clicked).

  Small or coarse-pointer viewports: opens the PDF in a new tab instead
  of the modal — iOS renders iframed PDFs first-page-only with no way
  to scroll.
*/
(() => {
  class SafetyReportCards extends HTMLElement {
    connectedCallback() {
      this.addEventListener(
        'click',
        (event) => {
          const button = event.target.closest('.safety-reports__card-button');

          if (!button || !this.contains(button)) {
            return;
          }

          if (this.#shouldOpenInNewTab) {
            event.preventDefault();
            event.stopImmediatePropagation();
            window.open(button.dataset.pdfUrl, '_blank', 'noopener');
            return;
          }

          const modal = document.getElementById(button.getAttribute('aria-controls'));
          const iframe = modal?.querySelector('iframe[data-src]');

          if (iframe && !iframe.src) {
            iframe.src = iframe.dataset.src;
          }
        },
        { capture: true }
      );
    }

    get #shouldOpenInNewTab() {
      return window.matchMedia('(max-width: 699px), (pointer: coarse)').matches;
    }
  }

  if (!window.customElements.get('safety-report-cards')) {
    window.customElements.define('safety-report-cards', SafetyReportCards);
  }
})();
